import { AuthActionType } from "components/Auth/constants";
import { USER_SIGNUP_PROP } from "components/User/constants";

export const getDefaultState = () => ({
  loggedIn: false,
  showResendEmail: false,
  fetching: true,
  verified: false,
  role: "",
  register: {
    [USER_SIGNUP_PROP.EMAIL]: "",
    [USER_SIGNUP_PROP.FNAME]: "",
    [USER_SIGNUP_PROP.LNAME]: "",
    [USER_SIGNUP_PROP.AFFILIATION]: "",
    [USER_SIGNUP_PROP.HEARABOUTUS]: "",
    [USER_SIGNUP_PROP.PASSWORD]: "",
    [USER_SIGNUP_PROP.REPEAT_PASSWORD]: "",
    inviteType: "",
  },
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case AuthActionType.SET_AUTH:
      return setAuth(state, action);
    case AuthActionType.SET_FETCHING:
      return setFetching(state, action);
    case AuthActionType.SET_ROLE:
      return setRole(state, action);
    case AuthActionType.SET_REGISTRATION:
      return setRegistration(state, action);
    case AuthActionType.SET_VERIFIED:
      return setVerified(state, action);
    case AuthActionType.AUTH_ERROR:
      return setAuthState(state, action);
    case AuthActionType.SET_INVITE_DATA:
      return {
        ...state,
        register: {
          ...state.register,
          role: action.data.role,
          email: action.data.email || "",
          inviteType: action.data.type,
        },
      };
    default:
      return state;
  }
};

const setAuthState = (state, {payload:{ error }}) => {
  return {
    ...state,
    showResendEmail: error,
  };
}

const setVerified = (state, {payload: { verified }} ) => {
  return {
    ...state,
    verified: verified,
  };
}

const setFetching = (state, { fetching }) => {
  return {
    ...state,
    fetching,
  };
};

const setAuth = (state, { loggedIn }) => {
  return {
    ...state,
    loggedIn,
    fetching: false,
  };
};

const setRole = (state, { role }) => {
  return {
    ...state,
    role,
  };
};

const setRegistration = (state, { register }) => {
  return {
    ...state,
    register,
  };
};
